import { SelectedVariants } from '@wix/bookings-uou-types';

export const aggregateParticipantVariants = (
  participantVariants: (SelectedVariants | undefined)[] | undefined,
): SelectedVariants[] => {
  const byChoice = new Map<string, SelectedVariants>();
  participantVariants?.forEach((variant) => {
    const choice = variant?.choices?.[0];
    if (!choice) {
      return;
    }
    const key = `${choice.optionId}::${choice.id}`;
    const existing = byChoice.get(key);
    if (existing) {
      existing.numberOfParticipants =
        (existing.numberOfParticipants || 0) +
        (variant.numberOfParticipants || 1);
    } else {
      byChoice.set(key, {
        numberOfParticipants: variant.numberOfParticipants || 1,
        choices: [{ ...choice }],
      });
    }
  });

  return Array.from(byChoice.values());
};

export const expandParticipantVariants = (
  selectedVariants: SelectedVariants[] | undefined,
): SelectedVariants[] => {
  const expanded: SelectedVariants[] = [];
  selectedVariants?.forEach((variant) => {
    const count = variant?.numberOfParticipants || 0;
    const choice = variant?.choices?.[0];
    for (let index = 0; index < count; index++) {
      expanded.push({
        numberOfParticipants: 1,
        choices: choice ? [{ ...choice }] : [],
      });
    }
  });
  return expanded;
};
